// extracted by mini-css-extract-plugin
export default {"billing":"BillingArea_billing__IilYm","billing__topBlock":"BillingArea_billing__topBlock__M1+XG","billing__topBlock__title":"BillingArea_billing__topBlock__title__ij+4V"};